import * as angular from "angular";
import {IController} from "angular";

export class AdditionsTableCtrl implements IController {

  additions: any;
  defaultId: string;
  onEdit: Function;
  onClick: Function;
  onPriceChange: Function;
  onDefault: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('additionsTable', {
    bindings: {
      additions: '<',
      canEdit: '<?',
      settingsMap: '<?',
      canDelete: '<?',
      onEdit: '&',
      onDelete: '&',
      onPriceChange: '&',
      onSettingsValueChange: '&'
    },
    template: require('./additions-table.html').default,
    controller: AdditionsTableCtrl
  });
